import { render, staticRenderFns } from "./FormButtons.vue?vue&type=template&id=0416017e&scoped=true&"
import script from "./FormButtons.vue?vue&type=script&lang=ts&"
export * from "./FormButtons.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0416017e",
  null
  
)

export default component.exports